import React, { useCallback, useEffect, useState } from 'react'
import { Tables } from '../../components/Elements/Tables/Tables'
import { ReactComponent as EyeIcon } from '../../assets/svgs/eye-icon.svg'
import { SearchBar } from '../../components/Elements/Search/SearchBar'
import { ReactComponent as BackIcon } from '../../assets/svgs/back-square.svg'
import { useNavigate } from 'react-router-dom'
import TextStyles from '../../components/Elements/TextStyles/TextStyles'
import { getApi } from '../../api/api_instance'
import CustomButton from '../../components/Elements/Buttons/CustomButtons'
import { API_URLS } from '../../api/apiUrls'
import QuestionDialog from '../StandardForms/DialogBoxes/QuestionDialog'
import { useDebounce } from '../../hooks/debouncing'
const QuestionBank = () => {
  const navigate = useNavigate()
  const [currentPage, setCurrentPage] = useState(1)
  const [tableData, setTableData] = useState([])
  const [totalRecords, setTotalRecords] = useState(0)
  const [pageSize, setPageSize] = useState(10)
  const [searchTerm, setSearchTerm] = useState('')
  const [loading, setLoading] = useState(false)
  const [openCreateDialog, setOpenCreateDialog] = useState(false)
 const debouncedSearch = useDebounce(searchTerm, 500);
  const fetchTableData = useCallback(async () => {
    try {
      setLoading(true)
      const response = await getApi({
        apiUrl: API_URLS.ALL_SECTIONS(currentPage, pageSize, debouncedSearch)
      })
      if (response.success) {
        setTotalRecords(response?.total || 0)
        const data = response?.data || []

        const formattedData = (response?.data || []).map((item, index) => ({
          key: item.id,
          serial: (currentPage - 1) * pageSize + index + 1,
          section: item.name || '-',
          totalSubSection: item.totalSubsections || 0,
          totalQuestion: item.totalQuestions || 0,
          action: (
            <div className='flex gap-4 justify-center align-center'>
              <EyeIcon
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  navigate('/question-bank/sub-section', {
                    state: { sectionId: item.section }
                  })
                }}
              />
            </div>
          )
        }))
        setTableData(formattedData)
      } else {
        setTableData([])
      }
    } catch (error) {
      console.error('Error fetching section data:', error)
      setTableData([])
    } finally {
      setLoading(false)
    }
  }, [currentPage, pageSize, debouncedSearch, navigate])

  const headers = [
    { label: 'Sr. No.', key: 'serial' },
    { label: 'Section Name', key: 'section' },
    { label: 'Total Sub-Section', key: 'totalSubSection' },
    { label: 'Total Question', key: 'totalQuestion' },
    { label: 'Action', key: 'action' }
  ]

  const handlePageChange = useCallback(page => {
    setCurrentPage(page)
  }, [])

  useEffect(() => {
    fetchTableData()
  }, [fetchTableData])

  return (
    <div style={{ backgroundColor: '#fff' }} className='h-screen px-[20px]'>
      <div className='flex justify-end text-xs font-light p-3'>
        <p>Home</p>
        <span>/</span>
        <TextStyles color='gradient'>My Question Bank</TextStyles>
      </div>
      <div className='flex items-center gap-2 text-xl font-bold px-2'>
        {/* <BackIcon /> */}
        <TextStyles color='gradient'>Sections</TextStyles>
      </div>

      <div
        style={{
          border: '1px solid #3BA2B959',
          borderRadius: '10px',
          paddingTop: '20px',
          boxShadow: '0px 0px 16px 0px #3BA2B91F'
        }}
      >
        <div className='flex justify-between mx-8'>
          <div className='flex gap-4 pl-3'>
            <p className='px-8  h-[42px] flex items-center justify-center border border-[#06513D] bg-[#B6D4D933] rounded-md text-[#06513D] text-base font-light'>
              TOTAL SECTION {totalRecords}
            </p>

            <SearchBar width='300px' onSearch={value => setSearchTerm(value)} />
          </div>
          <div className='flex gap-5'>
            <CustomButton
              buttonType='button'
              variant='ok'
              buttonText=' View All Question'
              className='text-[16px] font-normal h-[50px] w-[200px]'
              onClick={() => navigate('/question-bank/view-all')}
            />
          </div>
        </div>
        <div className='mx-2 pt-2'>
          <Tables
            data={tableData}
            headers={headers}
            pageSize={pageSize}
            total={totalRecords}
            current={currentPage}
            loading={loading}
            onChange={handlePageChange}
          />
        </div>
      </div>
      {openCreateDialog && (
        <QuestionDialog
          onOpen={openCreateDialog}
          onClose={() => setOpenCreateDialog(false)}
        />
      )}
    </div>
  )
}

export default QuestionBank
